import NewNote from './NewNote';

export default NewNote;



// WEBPACK FOOTER //
// ./src/containers/site-visits/stationDetail/components/newNote/index.js